import styled from "styled-components";

export const ContactWrapper = styled.div`
  color: white;
  padding: 30px;
  display: flex;
  flex-direction: column;
  text-align: center;
  margin: 50px 0;
  max-width: 1400px;
  margin-inline: auto;
  h1 {
    font-size: 50px;
    margin-bottom: 50px;
  }
  @media (max-width: 950px) {
    margin-top: 80px;
  }
`;

export const ContactInfo = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;

  gap: 30px;
  @media (max-width: 950px) {
    grid-template-columns: 1fr;
  }
`;
export const Info = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  text-align: start;
  color: var(--color-main-text);
  h4 {
    font-size: 16px;
    font-weight: 500;
    text-align: start;
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
  }
  h1 {
    margin-top: 20px;
  }
`;
